import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UnderlineTabs } from "@/shared/components/ui/Tabs";
import ProspectPageHeader from "./ProspectPageHeader";
import ProspectsTab from "./prospects/ProspectsTab";
import AccountsTab from "./accounts/AccountsTab";
import { PROSPECT_PAGE_TABS, PROSPECT_ROUTE } from "../constants/prospectConfig";
import type { ProspectPageTab } from "../types";

const UnderlineTabsComponent = UnderlineTabs as React.ComponentType<any>;

export default function ProspectPage() {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab?: string }>();
  const activeTab: ProspectPageTab = tab === "accounts" ? "accounts" : "contacts";
  // Accounts loads on first visit, then stays mounted so its results survive tab switches.
  const [accountsVisited, setAccountsVisited] = useState(activeTab === "accounts");
  useEffect(() => {
    if (activeTab === "accounts") setAccountsVisited(true);
  }, [activeTab]);

  const handleTabClick = (key: string) => {
    navigate(`${PROSPECT_ROUTE}/${key}`);
  };

  return (
    <div className="flex flex-col gap-4">
      <ProspectPageHeader tab={activeTab} />
      <UnderlineTabsComponent
        tab={activeTab}
        selectedKey={activeTab}
        handleTabClick={handleTabClick}
        onSelectionChange={handleTabClick}
        tabs={PROSPECT_PAGE_TABS}
      />
      {/* tabs */}
      <div className="bg-white dark:bg-gray-900 w-full h-[calc(100dvh-150px)] overflow-y-auto scrollbar-hide">
        <div className={activeTab === "contacts" ? "h-full" : "hidden"}>
          <ProspectsTab />
        </div>
        {accountsVisited && (
          <div className={activeTab === "accounts" ? "h-full" : "hidden"}>
            <AccountsTab isActive={activeTab === "accounts"} />
          </div>
        )}
      </div>
    </div>
  );
}
